import { render, staticRenderFns } from "./bgys-policy.vue?vue&type=template&id=bc264e90"
import script from "./bgys-policy.vue?vue&type=script&lang=js"
export * from "./bgys-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports